import ClubFaq from './ClubFaq';

export default ClubFaq;
